/* eslint-disable */
import {axios} from "~/plugins/axios";

const getDefaultState_Operators = () => {
  return {
    report: [],
    reportProjects: [],
    reportProjectsWeekAll: [],
    reportEmployment: {},
    droppedСallsReport: [],
    tariff: {},
  }
}
const state = getDefaultState_Operators();

const getters = {
  report: state => state.report,
  reportProjects: state => state.reportProjects,
  reportProjectsWeekAll: state => state.reportProjectsWeekAll,
  reportEmployment: state => state.reportEmployment,
  droppedСallsReport: state => state.droppedСallsReport,
}

const actions = {
  async loadWiretappingReport({commit}, payload) {
    commit('shared/SET_LOADING', true, {root: true});
    await axios.get('/api/reports/quality-of-work/by-operators', {params: payload})
      .then(response => {
        commit('shared/SET_LOADING', false, {root: true});
        commit('SET_REPORT', response.data.data);
      })
  },

  async loadQualityOperatorsReport({commit, dispatch}, payload) {
    commit('shared/SET_LOADING', true, {root: true});
    await axios.post('/api/reports/quality-of-work/operators-quality', payload)
      .then(response => {
        commit('shared/SET_LOADING', false, {root: true});
        commit('SET_REPORT', response.data.data);

        response.data.data.map(item => {
          dispatch('loadDroppedCallsReport', {
            agent: item.sip,
            period: payload.period,
          });
        });

      }).catch(error => {
        commit('shared/SET_LOADING', false, {root: true});
        commit('shared/SET_ERROR', error.request, {root: true});
      });
  },

  async loadQualityByProjects({commit}, payload) {
    commit('shared/SET_LOADING', true, {root: true});
    await axios.post('/api/reports/quality-of-work/operators-quality', payload)
      .then(response => {
        commit('SET_REPORT_PROJECTS', response.data.data);
        commit('shared/SET_LOADING', false, {root: true});

      }).catch(error => {
        commit('shared/SET_LOADING', false, {root: true});
        commit('shared/SET_ERROR', error.request, {root: true});
      });
  },

  async loadQualityByProjectsWeek1({commit}, payload) {

    var d1 = new Date(payload.period[0])
    // var d2 = new Date(payload.period[1])
    d1.setDate(d1.getDate() - 7)
    payload.period = [
      d1.getFullYear() + "-" + ("00" + (d1.getMonth() + 1)).slice(-2) + "-" + ("00" + d1.getDate()).slice(-2) + " " + ("00" + d1.getHours()).slice(-2) + ":" + ("00" + d1.getMinutes()).slice(-2) + ":" + ("00" + d1.getSeconds()).slice(-2),
      payload.period[1]
    ]

    payload.by_projects = false

    commit('shared/SET_LOADING', true, {root: true});
    await axios.post('/api/reports/quality-of-work/operators-quality', payload)
      .then(response => {
        commit('SET_REPORT_PROJECTS_WEEK1', response.data.data);
        commit('shared/SET_LOADING', false, {root: true});

      }).catch(error => {
        commit('shared/SET_LOADING', false, {root: true});
        commit('shared/SET_ERROR', error.request, {root: true});
      });
  },

  async loadQualityByProjectsWeek2({commit}, payload) {

    var d1 = new Date(payload.period[0])
    var d2 = new Date(payload.period[1])
    d1.setDate(d1.getDate() - 14)
    d2.setDate(d2.getDate() - 7)
    payload.period = [
      d1.getFullYear() + "-" + ("00" + (d1.getMonth() + 1)).slice(-2) + "-" + ("00" + d1.getDate()).slice(-2) + " " + ("00" + d1.getHours()).slice(-2) + ":" + ("00" + d1.getMinutes()).slice(-2) + ":" + ("00" + d1.getSeconds()).slice(-2),
      d2.getFullYear() + "-" + ("00" + (d2.getMonth() + 1)).slice(-2) + "-" + ("00" + d2.getDate()).slice(-2) + " " + ("00" + d2.getHours()).slice(-2) + ":" + ("00" + d2.getMinutes()).slice(-2) + ":" + ("00" + d2.getSeconds()).slice(-2)
    ]

    payload.by_projects = false

    commit('shared/SET_LOADING', true, {root: true});
    await axios.post('/api/reports/quality-of-work/operators-quality', payload)
      .then(response => {
        commit('SET_REPORT_PROJECTS_WEEK2', response.data.data);
        commit('shared/SET_LOADING', false, {root: true});

      }).catch(error => {
        commit('shared/SET_LOADING', false, {root: true});
        commit('shared/SET_ERROR', error.request, {root: true});
      });
  },

  async loadQualityByProjectsWeek3({commit}, payload) {

    var d1 = new Date(payload.period[0])
    var d2 = new Date(payload.period[1])
    d1.setDate(d1.getDate() - 21)
    d2.setDate(d2.getDate() - 14)
    payload.period = [
      d1.getFullYear() + "-" + ("00" + (d1.getMonth() + 1)).slice(-2) + "-" + ("00" + d1.getDate()).slice(-2) + " " + ("00" + d1.getHours()).slice(-2) + ":" + ("00" + d1.getMinutes()).slice(-2) + ":" + ("00" + d1.getSeconds()).slice(-2),
      d2.getFullYear() + "-" + ("00" + (d2.getMonth() + 1)).slice(-2) + "-" + ("00" + d2.getDate()).slice(-2) + " " + ("00" + d2.getHours()).slice(-2) + ":" + ("00" + d2.getMinutes()).slice(-2) + ":" + ("00" + d2.getSeconds()).slice(-2)
    ]

    payload.by_projects = false

    commit('shared/SET_LOADING', true, {root: true});
    await axios.post('/api/reports/quality-of-work/operators-quality', payload)
      .then(response => {
        commit('SET_REPORT_PROJECTS_WEEK3', response.data.data);
        commit('shared/SET_LOADING', false, {root: true});

      }).catch(error => {
        commit('shared/SET_LOADING', false, {root: true});
        commit('shared/SET_ERROR', error.request, {root: true});
      });
  },

  async loadQualityByProjectsWeek4({commit}, payload) {

    var d1 = new Date(payload.period[0])
    var d2 = new Date(payload.period[1])
    d1.setDate(d1.getDate() - 28)
    d2.setDate(d2.getDate() - 21)
    payload.period = [
      d1.getFullYear() + "-" + ("00" + (d1.getMonth() + 1)).slice(-2) + "-" + ("00" + d1.getDate()).slice(-2) + " " + ("00" + d1.getHours()).slice(-2) + ":" + ("00" + d1.getMinutes()).slice(-2) + ":" + ("00" + d1.getSeconds()).slice(-2),
      d2.getFullYear() + "-" + ("00" + (d2.getMonth() + 1)).slice(-2) + "-" + ("00" + d2.getDate()).slice(-2) + " " + ("00" + d2.getHours()).slice(-2) + ":" + ("00" + d2.getMinutes()).slice(-2) + ":" + ("00" + d2.getSeconds()).slice(-2)
    ]

    payload.by_projects = false

    commit('shared/SET_LOADING', true, {root: true});
    await axios.post('/api/reports/quality-of-work/operators-quality', payload)
      .then(response => {
        commit('SET_REPORT_PROJECTS_WEEK4', response.data.data);
        commit('shared/SET_LOADING', false, {root: true});

      }).catch(error => {
        commit('shared/SET_LOADING', false, {root: true});
        commit('shared/SET_ERROR', error.request, {root: true});
      });
  },

  async loadMatrixReport({commit}, payload) {
    commit('shared/SET_LOADING', true, {root: true});
    await axios.post('/api/reports/matrix', payload)
      .then(response => {
        commit('shared/SET_LOADING', false, {root: true});
        commit('SET_REPORT', response.data.data);
      })
      .catch(error => {
        if (error.response) {
          commit('shared/SET_ERROR', error.response.data, {root: true});
        } else if (error.request) {
          commit('shared/SET_ERROR', error.request, {root: true});
        } else {
          commit('shared/SET_ERROR', error.message, {root: true});
        }
      });
  },

  async loadDroppedCallsReport({commit}, params) {
    // commit('shared/SET_LOADING', true, {root: true});
    axios.get('/api/reports/quality-of-work/dropped-calls', {params: params})
      .then(response => {
        // commit('shared/SET_LOADING', false, {root: true});
        commit('SET_DROPPED_CALLS_REPORT', response.data);
        commit('ADD_DROPPED_AGENT_STAT', {
          sip: params.agent,
          count: response.data.length,
        });
      })
  },

  async loadIgnoreReport({commit}, payload) {
    commit('shared/SET_LOADING', true, {root: true});
    return await axios.post('/api/reports/quality-of-work/skipped', payload)
      .then(response => {
        commit('shared/SET_LOADING', false, {root: true});
        commit('SET_REPORT', response.data);
        return response.data
      })
      .catch(error => {
        if (error.response) {
          commit('shared/SET_ERROR', error.response.data, {root: true});
        } else if (error.request) {
          commit('shared/SET_ERROR', error.request, {root: true});
        } else {
          commit('shared/SET_ERROR', error.message, {root: true});
        }
        commit('shared/SET_LOADING', false, {root: true});
      });
  },

  async loadHoldReport({commit}, payload) {
    commit('shared/SET_LOADING', true, {root: true});
    return await axios.post('/api/reports/quality-of-work/holds', payload)
      .then(response => {
        commit('shared/SET_LOADING', false, {root: true});
        commit('SET_REPORT', response.data);
        return response.data
      })
      .catch(error => {
        if (error.response) {
          commit('shared/SET_ERROR', error.response.data, {root: true});
        } else if (error.request) {
          commit('shared/SET_ERROR', error.request, {root: true});
        } else {
          commit('shared/SET_ERROR', error.message, {root: true});
        }
        commit('shared/SET_LOADING', false, {root: true});
      });
  },

  async loadDropReport({commit}, payload) {
    commit('shared/SET_LOADING', true, {root: true});
    return await axios.post('/api/reports/quality-of-work/drops', payload)
      .then(response => {
        commit('shared/SET_LOADING', false, {root: true});
        commit('SET_REPORT', response.data);
        return response.data
      })
      .catch(error => {
        if (error.response) {
          commit('shared/SET_ERROR', error.response.data, {root: true});
        } else if (error.request) {
          commit('shared/SET_ERROR', error.request, {root: true});
        } else {
          commit('shared/SET_ERROR', error.message, {root: true});
        }
        commit('shared/SET_LOADING', false, {root: true});
      });
  },

  async loadEmploymentReport({commit}, payload) {
    commit('shared/SET_LOADING', true, {root: true});
    commit('SET_REPORT', []);
    let report = await axios.post('/api/reports/employment', payload)
      .then(response => {
        commit('shared/SET_LOADING', false, {root: true});
        commit('SET_EMPLOYMENT_REPORT', response.data);
        return response.data.items
      })
      .catch(error => {
        if (error.response) {
          commit('shared/SET_ERROR', error.response.data, {root: true});
        } else if (error.request) {
          commit('shared/SET_ERROR', error.request, {root: true});
        } else {
          commit('shared/SET_ERROR', error.message, {root: true});
        }
        commit('shared/SET_LOADING', false, {root: true});
      });
    return report;
  },

  async getEmploymentInfo({commit}, payload) {
    let res;
    await axios.get('/api/reports/employment/get', {params: payload})
      .then(response => {
        res = response.data.data;
      })
    return res
  },

  addEmploymentInfo({commit}, payload) {
    axios.post('/api/reports/employment/add', payload)
      .then(response => {
        commit('shared/SET_SUCCESS', {message: response.data.message}, {root: true});
      })
      .catch(error => {
        if (error.response) {
          commit('shared/SET_ERROR', error.response.data, {root: true});
        } else if (error.request) {
          commit('shared/SET_ERROR', error.request, {root: true});
        } else {
          commit('shared/SET_ERROR', error.message, {root: true});
        }
      });
  },

  deleteEmploymentInfo({commit}, id) {
    axios.delete(`/api/reports/employment/${id}`)
      .then(response => {
        commit('shared/SET_SUCCESS', {message: response.data.message}, {root: true});
      })
      .catch(error => {
        if (error.response) {
          commit('shared/SET_ERROR', error.response.data, {root: true});
        } else if (error.request) {
          commit('shared/SET_ERROR', error.request, {root: true});
        } else {
          commit('shared/SET_ERROR', error.message, {root: true});
        }
      });
  },

  clearTimelineReport({commit}) {
    commit('CLEAR_REPORT_TIMELINE');
  },

  clearReport({commit}) {
    commit('SET_REPORT', []);
  },
  
  clearQualityByProjects({commit}) {
    commit('SET_REPORT_PROJECTS', null);
  },

  createOperatorSchedule({commit}, payload) {
    commit('shared/SET_LOADING', true, {root: true});
    const userId = payload.userId
    delete payload.userId
    
    return axios.post(`/api/users/${userId}/operator-schedules`, payload)
      .then(response => {
        commit('shared/SET_SUCCESS', {message: response.data.message}, {root: true})
        return response.data.data
      })
      .catch(error => {
        if (error.response) {
          commit('shared/SET_ERROR', error.response.data, {root: true});
        } else if (error.request) {
          commit('shared/SET_ERROR', error.request, {root: true});
        } else {
          commit('shared/SET_ERROR', error.message, {root: true});
        }
      })
      .finally(() => {
        commit('shared/SET_LOADING', false, {root: true});
      })
  },

  updateOperatorSchedule({commit}, payload) {
    commit('shared/SET_LOADING', true, {root: true});
    const userId = payload.userId
    const scheduleId = payload.scheduleId
    delete payload.userId
    delete payload.scheduleId
    
    return axios.patch(`/api/users/${userId}/operator-schedules/${scheduleId}`, payload)
      .then(response => {
        commit('shared/SET_SUCCESS', {message: response.data.message}, {root: true})
        return response.data.data
      })
      .catch(error => {
        if (error.response) {
          commit('shared/SET_ERROR', error.response.data, {root: true});
        } else if (error.request) {
          commit('shared/SET_ERROR', error.request, {root: true});
        } else {
          commit('shared/SET_ERROR', error.message, {root: true});
        }
      })
      .finally(() => {
        commit('shared/SET_LOADING', false, {root: true});
      })
  },

  massUpdateOperatorSchedule({commit}, payload) {
    commit('shared/SET_LOADING', true, {root: true});
    const userId = payload.userId
    delete payload.userId
    
    return axios.post(`/api/users/${userId}/operator-schedules/mass-filling`, payload)
      .then(response => {
        commit('shared/SET_SUCCESS', {message: response.data.message}, {root: true})
        return response.data.data
      })
      .catch(error => {
        if (error.response) {
          commit('shared/SET_ERROR', error.response.data, {root: true});
        } else if (error.request) {
          commit('shared/SET_ERROR', error.request, {root: true});
        } else {
          commit('shared/SET_ERROR', error.message, {root: true});
        }
      })
      .finally(() => {
        commit('shared/SET_LOADING', false, {root: true});
      })
  },

  destroyOperatorSchedule({commit}, payload) {
    commit('shared/SET_LOADING', true, {root: true});
    const userId = payload.userId
    const scheduleId = payload.scheduleId
    delete payload.userId
    delete payload.scheduleId
    
    return axios.delete(`/api/users/${userId}/operator-schedules/${scheduleId}`, payload)
      .then(response => {
        commit('shared/SET_SUCCESS', {message: response.data.message}, {root: true})
        return response.data.data
      })
      .catch(error => {
        if (error.response) {
          commit('shared/SET_ERROR', error.response.data, {root: true})
        } else if (error.request) {
          commit('shared/SET_ERROR', error.request, {root: true})
        } else {
          commit('shared/SET_ERROR', error.message, {root: true})
        }
      })
      .finally(() => {
        commit('shared/SET_LOADING', false, {root: true})
      })
  },

  async autoFillEmployment({commit}, payload) {
    commit('shared/SET_LOADING', true, {root: true})

    await axios.post('/api/schedule/auto-filling', payload)
      .then(response => {
        commit('shared/SET_SUCCESS', {message: response.data.message}, {root: true})
      })
      .catch(error => {
        if (error.response) {
          commit('shared/SET_ERROR', error.response.data, {root: true})
        } else if (error.request) {
          commit('shared/SET_ERROR', error.request, {root: true})
        } else {
          commit('shared/SET_ERROR', error.message, {root: true})
        }
      })
      .finally(() => {
        commit('shared/SET_LOADING', false, {root: true})
      })
  },

  async recalculateEmployment({commit}, payload) {
    commit('shared/SET_LOADING', true, {root: true})

    const userId = payload.userId
    delete payload.userId

    return await axios.post(`/api/users/${userId}/recalculate-employment`, payload)
      .then(response => {
        return response.data.data
      })
      .catch(error => {
        if (error.response) {
          commit('shared/SET_ERROR', error.response.data, {root: true})
        } else if (error.request) {
          commit('shared/SET_ERROR', error.request, {root: true})
        } else {
          commit('shared/SET_ERROR', error.message, {root: true})
        }
      })
      .finally(() => {
        commit('shared/SET_LOADING', false, {root: true})
      })
  },
}

const mutations = {
  SET_REPORT(state, data) {
    state.report = data;
  },

  SET_REPORT_PROJECTS(state, data) {
    state.reportProjects = data;
  },

  SET_REPORT_PROJECTS_WEEK1(state, data) {
    state.reportProjectsWeekAll = []
    if (data[0] !== undefined) data[0].week_num = "1"
    state.reportProjectsWeekAll = state.reportProjectsWeekAll.concat(data);
  },

  SET_REPORT_PROJECTS_WEEK2(state, data) {
    if (data[0] !== undefined) data[0].week_num = "2"
    state.reportProjectsWeekAll = state.reportProjectsWeekAll.concat(data);
  },

  SET_REPORT_PROJECTS_WEEK3(state, data) {
    if (data[0] !== undefined) data[0].week_num = "3"
    state.reportProjectsWeekAll = state.reportProjectsWeekAll.concat(data);
  },

  SET_REPORT_PROJECTS_WEEK4(state, data) {
    if (data[0] !== undefined) data[0].week_num = "4"
    state.reportProjectsWeekAll = state.reportProjectsWeekAll.concat(data);
  },

  SET_DROPPED_CALLS_REPORT(state, data) {
    state.droppedСallsReport = data;
  },

  SET_EMPLOYMENT_REPORT(state, data) {
    state.reportEmployment = data;
  },

  ADD_DROPPED_AGENT_STAT(state, data) {
    const agentItem = state.report.find(item => item.sip === data.sip);

    if (agentItem === undefined) return;

    const index = state.report.indexOf(agentItem);

    state.report[index].dropped_calls_count = data.count;
  },

  RESET_STATE_OPERATORS (state) {
    Object.assign(state, getDefaultState_Operators())
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
